import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-select-all',
    styleUrls: ['./select-all.component.scss'],
    templateUrl: './select-all.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SelectAllComponent {

  @Input() public all: number = 0;
  @Input() public selected: number = 0;
  @Output() public selectAll = new EventEmitter<void>();
  @Output() public unselectAll = new EventEmitter<void>();

  constructor(
  ) { }

  public toggle(selected: boolean): void {
    if (selected) {
      this.selectAll.emit();
    } else {
      this.unselectAll.emit();
    }
  }

}
